import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgDownload(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M25.7677 14.9999L16.8838 23.8838C16.6494 24.1182 16.3315 24.2499 15.9999 24.2499C15.6684 24.2499 15.3505 24.1182 15.116 23.8838L6.23217 14.9999L7.99993 13.2322L14.7499 19.9821L14.7499 2.75L17.2499 2.75L17.2499 19.9822L23.9999 13.2322L25.7677 14.9999Z"
      />
      <path fill="currentColor" d="M27 26.7499H5V29.2499H27V26.7499Z" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
